import React, { useState } from "react";
import { Controller } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { Text, TextInput, View } from "react-native";

interface InputPasswordProps {
  control: any;
  name: string;
  label: string;
  rules?: any;
  error?: boolean;
  value?: string;
  optional?: boolean;
  hidden?: boolean;
}

export default function InputPassword(props: InputPasswordProps) {
  const [password, setPassword] = useState("");
  const [hasTyped, setHasTyped] = useState(false);
  const { t } = useTranslation();

  const passwordCriteria = {
    minLength: {
      test: (val) => val.length >= 8,
      message: "Password needs at least 8 characters",
    },
    minLowercase: {
      test: (val) => /[a-z]/.test(val),
      message: "Password needs at least one lower letter",
    },
    minUppercase: {
      test: (val) => /[A-Z]/.test(val),
      message: "Password needs at least one upper letter",
    },
    minNumbers: {
      test: (val) => /[0-9]/.test(val),
      message: "Password needs at least one number",
    },
    minSymbols: {
      test: (val) => /[^A-Za-z0-9]/.test(val),
      message: "Password needs at least one special character",
    },
  };

  const getMessageStyle = (criteria) => {
    return passwordCriteria[criteria].test(password);
  };

  return (
    <View>
      {props.optional === true ? (
        <View className="flex-row m-2">
          <Text className="text-black text-sm">{props.label}</Text>
          <Text className="text-midgray text-sm italic">{` (${t(
            "common:placeholder.optional",
          )})`}</Text>
        </View>
      ) : (
        <Text className="text-black text-sm m-2">{props.label}</Text>
      )}
      <Controller
        control={props.control}
        name={props.name}
        defaultValue=""
        render={({
          field: { onChange, onBlur, value, ref },
          fieldState: { error },
        }) => (
          <>
            <TextInput
              ref={ref}
              className={`border border-solid rounded-xl w-80 h-14 p-6 text-black1 ${
                error ? "border-red" : "border-midgray"
              }`}
              secureTextEntry
              onChangeText={(text) => {
                setHasTyped(true);
                setPassword(text);
                onChange(text);
              }}
              onBlur={onBlur}
              value={value}
            />
            <View style={{ height: 80, overflow: "hidden", marginTop: 4 }}>
              {(props.hidden && hasTyped) || !props.hidden
                ? Object.keys(passwordCriteria).map((criteria) => (
                    <Text
                      key={criteria}
                      style={getMessageStyle(criteria)}
                      className={`${
                        getMessageStyle(criteria)
                          ? "text-green text-xs px-5"
                          : "text-red text-xs px-5"
                      }`}
                    >
                      {passwordCriteria[criteria].message}
                    </Text>
                  ))
                : null}
            </View>
          </>
        )}
      />
    </View>
  );
}
